// extracted by mini-css-extract-plugin
export default {"root":"SectionHero_root__zeQDy","sectionContent":"SectionHero_sectionContent__PzgvV"};